import i18next from 'i18next'
import { initReactI18next } from 'react-i18next'

import bgCommon from './bg/common.json'
import bgFeature from './bg/feature.json'
import enCommon from './en/common.json'
import enFeature from './en/feature.json'

export const defaultNS = 'common'

// Statically bundled by Vite (no async backend). Exported so i18next.d.ts can
// derive key-typing off `bg` (the complete primary language).
export const resources = {
  bg: {
    common: bgCommon,
    feature: bgFeature,
  },
  en: {
    common: enCommon,
    feature: enFeature,
  },
} as const

i18next.use(initReactI18next).init({
  lng: 'bg',
  fallbackLng: 'bg',
  debug: false,
  resources,
  defaultNS,
  interpolation: {
    escapeValue: false,
  },
})

export { i18next }
